module.exports = __webpack_public_path__ + "static/media/preloader.8dd1c468.svg";